import { UPDATE_ENDPOINTS } from '../constants/index';

export const initialEndpoint = {   
    endpointOrg: [],

    endpointAdded: [],

    endpointDismissEvent: [],
    endpointInsightEvent: [],
    trialEndpointData:{}
}

const endpointReducer = (state = initialEndpoint, action) => {
	switch(action.type){
        case UPDATE_ENDPOINTS:
            state = {
                ...state,
                ...action.payload
            }
        break;
		default:			
    }
    return state
}
export default endpointReducer;